import { signOut } from 'aws-amplify/auth';
import { isAuthFailed, isUsableSession, loadSession } from '../services/auth';

export const logout = async () => {
  // Use global signOut to fully clear session from all devices and invalidate refresh tokens
  await signOut({ global: true });
};

export const getSession = async (force_refresh = false) => {
  if (isAuthFailed()) {
    return null;
  }
  try {
    const session = await loadSession(force_refresh);
    if (isUsableSession(session)) {
      return session;
    }
    return null;
  } catch (err) {
    console.log('Session refresh failed:', err);
    return null;
  }
};
